// 検索パラメータの保持
const getDefaultState = () => {
  return {
    searchCategory: 'qa', // ダッシュボード、メニューの検索カテゴリの選択状態
    qa_extract: {}, // QA一覧の絞り込み表示用の検索条件
    qa: {},
    knowledge: {},
    note: {},
    book: {},
    download: {},
    precedent: {}
    // search_text_input: '', // SearchUIコンポーネント外から検索UIのキーワード入力欄を更新するために使用
    // is_fuzzy_input: 0 // SearchUIコンポーネント外から検索UIの曖昧フラグを更新するために使用
  }
}
const defaultState = getDefaultState()

const search = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getQASearchParam: (state) => state.qa,
    getKnowledgeSearchParam: (state) => state.knowledge,
    getNoteSearchParam: (state) => state.note,
    getBookSearchParam: (state) => state.book,
    getDownloadSearchParam: (state) => state.donwload,
    getPrecedentSearchParam: (state) => state.precedent
  },
  mutations: {
    clearAll(state) {
      state.searchCategory = 'qa'
      state.qa = {}
      state.knowledge = {}
      state.note = {}
      state.book = {}
      state.download = {}
      state.precedent = {}
    },
    setSearchCategory: (state, searchCategory) => {
      state.searchCategory = searchCategory
    },
    setQASearchExtract: (state, params) => {
      state.qa_extract = Object.assign({}, params)
    },
    setQA: (state, params) => {
      state.qa = Object.assign({}, params)
    },
    setKnowledge: (state, params) => {
      state.knowledge = Object.assign({}, params)
    },
    setNote: (state, params) => {
      state.note = Object.assign({}, params)
    },
    setBook: (state, params) => {
      state.book = Object.assign({}, params)
    },
    setDownload: (state, params) => {
      state.download = Object.assign({}, params)
    },
    setPrecedent: (state, params) => {
      state.precedent = Object.assign({}, params)
    },
    resetQA: (state) => {
      state.qa = Object.assign({}, defaultState.qa)
    },
    resetKnowledge: (state) => {
      state.knowledge = Object.assign({}, defaultState.knowledge)
    },
    resetNote: (state) => {
      state.note = Object.assign({}, defaultState.note)
    },
    resetBook: (state) => {
      state.book = Object.assign({}, defaultState.book)
    },
    resetDownload: (state) => {
      state.download = Object.assign({}, defaultState.download)
    },
    resetPrecedent: (state) => {
      state.precedent = Object.assign({}, defaultState.precedent)
    }
    // setSearchInput: (state, params) => {
    //   state.search_text_input = params.search_text_input
    //   state.is_fuzzy_input = params.is_fuzzy_input
    // }
  },
  actions: {
    // 全ステートをクリア
    clearAll({ commit }) {
      commit('clearAll')
    },
    setSearchCategory: async({commit}, searchCategory) => {
      await commit('setSearchCategory', searchCategory)
    },
    // QA一覧の絞り込み表示用の検索条件を保存
    setQASearchExtractParam: async({commit}, params) => {
      await commit('setQASearchExtract', params)
    },
    setQASearchParam: async({commit}, params) => {
      await commit('setQA', params)
    },
    setKnowledgeSearchParam: async ({ commit }, params) => {
      await commit('setKnowledge', params)
    },
    setNoteSearchParam: async({ commit }, params) => {
      await commit('setNote', params)
    },
    setBookSearchParam: async ({ commit }, params) => {
      await commit('setBook', params)
    },
    setDownloadSearchParam: async ({ commit }, params) => {
      await commit('setDownload', params)
    },
    setPrecedentSearchParam: async ({ commit }, params) => {
      await commit('setPrecedent', params)
    },
    resetQA: ({ commit }) => commit('resetQA'),
    resetKnowledge: ({ commit }) => commit('resetKnowledge'),
    resetNote: ({ commit }) => commit('resetNote'),
    resetBook: ({ commit }) => commit('resetBook'),
    resetDownload: ({ commit }) => commit('resetDownload'),
    resetPrecedent: ({ commit }) => commit('resetPrecedent')
    // setSearchInput: ({ commit }, params) => {
    //   commit('setSearchInput', params)
    // }
  }
}

export default search
